import loadable from "@loadable/component";
import { inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import * as Webapi from "@ihr-radioedit/inferno-webapi";
import { spaceToUnderscore } from "../../lib/utilities";
import { slugify } from "@ihr-radioedit/inferno-core";
import { getDateFormat } from "@ihr-radioedit/inferno-core";
import { reverseRoute } from "../../lib/route";
import { Card, Container, Grid, Heading, MagicLink } from "../../ui";
import "./CalendarTile.style.scss";
import { Store } from "../../../../client/stores";

const ContentTile = loadable(() => import("../../components/tiles/ContentTile.component"));
interface CalenderTileProps {
    events: Webapi.CalendarEventFragment[];
    store?: Store;
}

export const CalendarTile = inject("store")(({ store, events }: CalenderTileProps) => {
    if (!store || events.length === 0) {
        return null;
    }
    const url = reverseRoute(store.site, "calendar") || "#";
    const { t } = useTranslation();

    return (
        <Container className="component-calendar-tile">
            <Heading
                level={2}
                link={{
                    text: t("view_more"),
                    label: `${t("view_more")} ${t("events")}`,
                    url,
                }}
            >
                <MagicLink to={url} sectionName="events" context="view_more">
                    {t("events")}
                </MagicLink>
            </Heading>
            <Grid columns={4}>
                {events.map((calendarItem, i) => {
                    const category = (calendarItem.tags[0] || "").replace("events/", "");

                    return (
                        <Card key={i}>
                            <ContentTile
                                eyebrow={{
                                    topic_name: t(spaceToUnderscore(category)),
                                    url:
                                        reverseRoute(store.site, "calendar_category", {
                                            category: slugify(category),
                                        }) || "",
                                }}
                                title={calendarItem.content.title}
                                url={reverseRoute(store.site, "calendar_detail", { eventid: calendarItem.id }) ?? ""}
                                slug={calendarItem.id}
                                thumb={calendarItem.content.img}
                                datetime={calendarItem.startDateTime}
                                dateFormat={getDateFormat(store.site)}
                            />
                        </Card>
                    );
                })}
            </Grid>
        </Container>
    );
});
